<div nz-row>
  <div nz-col [nzSm]="{span: 24}" [nzMd]="{span: 14, offset: 5}" [nzLg]="{span: 10, offset: 7}">
    <div class="alert-box">
    <nz-alert nzType="info" nzShowIcon [nzDescription]="description"></nz-alert>
    </div>
    <form nz-form [formGroup]="contactForm" class="login-form" (ngSubmit)="onContinue()">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="termsError">
          <nz-input-group>
            <label nz-checkbox formControlName="portalTcAccepted" required>I agree to the Hill Laboratories <u>
              <a href="{{applicationConstants.OFFICIAL_PAGE}}/OnlineTerms" target="_blank" (click)="$event.stopPropagation()">Online Terms &amp; Conditions</a></u>
              and <u><a href="{{applicationConstants.OFFICIAL_PAGE}}/PrivacyStatement" target="_blank" (click)="$event.stopPropagation()">Privacy Statement</a></u>.</label>
            <ng-template #termsError let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please accept the Online Terms &amp; Conditions and Privacy Statement
              </ng-container>
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <button nz-button type="submit" nzType="primary" nzBlock [nzLoading]="isUpdatingTerms">Continue</button>
      </nz-form-item>
      <nz-form-item>
        <button nz-button nzType="primary" nzBlock (click)="onLogout()" >Logout</button>
      </nz-form-item>
    </form>
  </div>
</div>